"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _misc = require("HubStyleTokens/misc");

var _UIAccordionItem = _interopRequireDefault(require("UIComponents/accordion/UIAccordionItem"));

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  .sidebar-section__title {\n    font-weight: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledUIAccordionItem = (0, _styledComponents.default)(_UIAccordionItem.default).withConfig({
  displayName: "SidebarSection__StyledUIAccordionItem",
  componentId: "sc-2fi0qp-0"
})(_templateObject(), _misc.WEB_FONT_DEMI_BOLD_WEIGHT);

var SidebarSection = function SidebarSection(_ref) {
  var children = _ref.children,
      title = _ref.title,
      _ref$tooltip = _ref.tooltip,
      tooltip = _ref$tooltip === void 0 ? '' : _ref$tooltip,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["children", "title", "tooltip"]);
  return _react.default.createElement(StyledUIAccordionItem, (0, _extends2.default)({}, rest, {
    className: "m-bottom-4",
    title: _react.default.createElement(_UITooltip.default, {
      delay: 200,
      disabled: !tooltip,
      placement: "right",
      title: tooltip
    }, _react.default.createElement("span", null, title)),
    titleClassName: "sidebar-section__title m-y-0"
  }), _react.default.createElement("div", {
    className: "p-top-2"
  }, children));
};

var _default = SidebarSection;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/storefront/sidebar/SidebarSection.js
// module id = 700
// module chunks = 209 210 211 212